import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['cancellationReasonSection', 'defaultCtas', 'reassignCtas']

  connect() {
    // Ensure initial state is correct
    this.hideReassignReason()
  }

  showReassignReason(event) {
    event.preventDefault()

    // Show cancellation reason section
    this.cancellationReasonSectionTarget.classList.remove('hidden')

    // Hide default CTAs and show reassign CTAs
    this.defaultCtasTarget.classList.add('hidden')
    this.reassignCtasTarget.classList.remove('hidden')

    // Focus on the text area
    const textArea = this.cancellationReasonSectionTarget.querySelector('textarea')
    if (textArea) {
      textArea.focus()
    }
  }

  cancelReassign(event) {
    event.preventDefault()
    this.hideReassignReason()

    // Clear the text area
    const textArea = this.cancellationReasonSectionTarget.querySelector('textarea')
    if (textArea) {
      textArea.value = ''
    }
  }

  hideReassignReason() {
    // Hide cancellation reason section
    this.cancellationReasonSectionTarget.classList.add('hidden')

    // Show default CTAs and hide reassign CTAs
    this.defaultCtasTarget.classList.remove('hidden')
    this.reassignCtasTarget.classList.add('hidden')
  }
}
